import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DrawDealService {

  constructor(private http: ApiHttpClient) { }

  ring(file: File): Observable<File> {
    const formData = new FormData();
    formData.append('file',  new File([file], file.name));
    return this.http.post<File>(`${environment.API_URL}/renewal-ring`, formData);
  }

  getResults(renewalLogId: number): Observable<number> {
    return this.http.get<number>(`${environment.API_URL}/renewal-ring-log/${renewalLogId}`);
  }
}
